function getAccountId() {
    const id = localStorage.getItem("id"); 
    
    return id;
}

export default getAccountId;